module.exports = __webpack_public_path__ + "static/media/mp4.eb6baddf.png";